// the values here come from https://github.com/multiformats/multiaddr/blob/master/protocols.csv
export const CODE_IP4 = 4;
export const CODE_TCP = 6;
export const CODE_UDP = 273;
export const CODE_DCCP = 33;
export const CODE_IP6 = 41;
export const CODE_IP6ZONE = 42;
export const CODE_IPCIDR = 43;
export const CODE_DNS = 53;
export const CODE_DNS4 = 54;
export const CODE_DNS6 = 55;
export const CODE_DNSADDR = 56;
export const CODE_SCTP = 132;
export const CODE_UDT = 301;
export const CODE_UTP = 302;
export const CODE_UNIX = 400;
export const CODE_P2P = 421; // also IPFS
export const CODE_ONION = 444;
export const CODE_ONION3 = 445;
export const CODE_GARLIC64 = 446;
export const CODE_GARLIC32 = 447;
export const CODE_TLS = 448;
export const CODE_SNI = 449;
export const CODE_NOISE = 454;
export const CODE_QUIC = 460;
export const CODE_QUIC_V1 = 461;
export const CODE_WEBTRANSPORT = 465;
export const CODE_CERTHASH = 466;
export const CODE_HTTP = 480;
export const CODE_HTTP_PATH = 481;
export const CODE_HTTPS = 443;
export const CODE_WS = 477;
export const CODE_WSS = 478;
export const CODE_P2P_WEBSOCKET_STAR = 479;
export const CODE_P2P_STARDUST = 277;
export const CODE_P2P_WEBRTC_STAR = 275;
export const CODE_P2P_WEBRTC_DIRECT = 276;
export const CODE_WEBRTC_DIRECT = 280;
export const CODE_WEBRTC = 281;
export const CODE_P2P_CIRCUIT = 290;
export const CODE_MEMORY = 777;
//# sourceMappingURL=constants.js.map